import { combineReducers } from "redux";
import {
  RCSAEntityPeriodCommand,
  RCSAEntityPeriodDefault,
  RCSAEntityPeriodReducer,
} from "./rsca/reducer";
import { ParameterSettingModel } from "./types";
import {
  TaxonomyCommand,
  TaxonomyDefault,
  TaxonomyReducer,
} from "./taxonomy/reducer";
import {
  AssignmentCommand,
  AssignmentDefault,
  AssignmentReducer,
} from "./assignment/reducer";
import {
  ProjectCommand,
  ProjectDefault,
  ProjectReducer,
} from "./project/reducer";
import {
  WorkflowCommand,
  WorkflowDefault,
  WorkflowReducer,
} from "./workflow/reducer";
import {
  KriTresholdCommand,
  KriTresholdDefault,
  KriTresholdReducer,
} from "./kri-treshold/reducer";
import {
  CriteriaCommand,
  CriteriaDefault,
  CriteriaReducer,
} from "./criteria/reducer";
import {
  ParameterPenilaianCommand,
  ParameterPenilaian as ParameterPenilaianDefault,
  ParameterPenilaianReducer,
} from "./scoring/parameter-penilaian/reducer";
import {
  TemplateMaturityCommand,
  TemplateMaturityDefault,
  TemplateMaturityReducer,
} from "./template-maturity/reducer";
import {
  ScoringCommand,
  Scoring,
  ScoringReducer
} from "./scoring/reducer"

const ParameterSettingReducer = combineReducers({
  rcsa: RCSAEntityPeriodReducer,
  taxonomy: TaxonomyReducer,
  assignment: AssignmentReducer,
  project: ProjectReducer,
  workflow: WorkflowReducer,
  kriTreshold: KriTresholdReducer,
  criteria: CriteriaReducer,
  criteriaAssessment: ParameterPenilaianReducer,
  templateMaturity: TemplateMaturityReducer,
  scoring: ScoringReducer,  // Add scoring reducer here
});

const ParameterSettingDefault: ParameterSettingModel = {
  rcsa: RCSAEntityPeriodDefault,
  taxonomy: TaxonomyDefault,
  assignment: AssignmentDefault,
  project: ProjectDefault,
  workflow: WorkflowDefault,
  kriTreshold: KriTresholdDefault,
  criteria: CriteriaDefault,
  criteriaAssessment: ParameterPenilaianDefault,
  templateMaturity: TemplateMaturityDefault,
  scoring: Scoring,  // Add scoring default here
};

const ParameterSettingCommand = {
  rcsa: RCSAEntityPeriodCommand,
  taxonomy: TaxonomyCommand,
  assignment: AssignmentCommand,
  project: ProjectCommand,
  workflow: WorkflowCommand,
  kriTreshold: KriTresholdCommand,
  criteria: CriteriaCommand,
  criteriaAssessment: ParameterPenilaianCommand,
  templateMaturity: TemplateMaturityCommand,
  scoring: ScoringCommand,  // Add scoring command here
};

export {
  ParameterSettingReducer,
  ParameterSettingDefault,
  ParameterSettingCommand,
};
